// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"3f6a10b3","807":"8d7fc5b5","969":"89414e98"}[chunkId] + ".chunk.css";
};